import React from 'react'

const ImageTooltip = ({children, image, width, height,offsetX, offsetY, zIndex=1}) => {

  const [state, setState] = React.useState({
    clientX: 0,
    clientY: 0,
  });
  const [display, setDisplay] = React.useState(false);

  const randomString = (len, charSet = "abcdefghijklmnopqrstuvwxyz") => {
    let randomString = "";
    for (let i = 0; i < len; i++) {
      let randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  };
  const uniqueClassName = randomString(4);

  const toogleImage = () => {
    setDisplay(!display);
  };

  const handleMouseOver = event => {
    const { clientX, clientY } = event;
    setState({
      clientX: clientX+offsetX,
      clientY: clientY+offsetY,
    });
  };

  return (
    <React.Fragment>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .${uniqueClassName}:after {
              visibility: ${display ? "visible" : "hidden"};
              opacity: ${display ? "1" : "0"};
              top: ${state.clientY - 50}px;
              left: ${state.clientX - 50}px;
            }
          `
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .${uniqueClassName}:after {
              background-image: url(${image});
              width: ${width ? `${width}px` : "300px"};
              height: ${height ? `${height}px` : "100%"};
              pointer-events: none;
              position: fixed;
              background-size: contain;
              background-repeat: no-repeat;
              z-index: ${zIndex};
              content: "";
            }
          }
          `
        }}
      />
      <span
        onMouseEnter={() => toogleImage()}
        onMouseLeave={() => toogleImage()}
        onMouseMoveCapture={handleMouseOver}
        onTouchStart={() => setDisplay(false)}
        className={uniqueClassName}
      >
          {children}
        </span>
    </React.Fragment>
  )
}

export default ImageTooltip
